import * as C from '../constants';
import * as I from '../interface';
import * as api from '../api';
import { createAction } from 'redux-actions';
import { fetchUserShopItemAll } from 'actions/UserShopItemActionCreators';

export const actionAddItemToFavourite = createAction(
  C.ACTION_TYPES.FAVOURITE_ADD_TO,
  (payload: {
    data_items?: DataItem[];
    shop_items?: ShopItem[];
    updateFocusedItem?: boolean;
  }) => ({ ...payload })
);

export const actionRemoveFromFavourite = createAction(
  C.ACTION_TYPES.FAVOURITE_REMOVE_FROM,
  (shop_items: ShopItem[], data_items: DataItem[]) => ({
    shop_item_ids: shop_items.map(x => x.id),
    data_item_ids: data_items.map(x => x.id),
  })
);

export const actionUpdateState = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_STATE,
  (state: C.STATE.FAVOURITE) => ({ state })
);

export const actionDataItemView = createAction(
  C.ACTION_TYPES.FAVOURITE_DATA_ITEM_VIEW,
  (data_item_views: DataItem[]) => ({ data_item_views })
);

export const actionDataItemPrices = createAction(
  C.ACTION_TYPES.FAVOURITE_DATA_ITEM_PRICES,
  (data_items: DataItem[]) => ({ data_items })
);

export const addShopItemToFavourite = (items: ShopItem[]) =>
  addItemToFavouriteApi(items, []);

export const addDataItemToFavourite = (items: DataItem[]) =>
  addItemToFavouriteApi([], items);

export const removeShopItemFromFavourite = (items: ShopItem[]) =>
  removeItemFromFavouriteApi(items, []);

export const removeDataItemFromFavourite = (items: DataItem[]) =>
  removeItemFromFavouriteApi([], items);

export const actionAddFavouriteDataItem = createAction(
  C.ACTION_TYPES.FAVOURITE_ADD_DATA_ITEMS,
  (items: DataItem[]) => ({ items })
);

export const clearFavouriteDataItems = createAction(
  C.ACTION_TYPES.FAVOURITE_CLEAR_DATA_ITEMS
);

export const actionClearFavouriteShopItems = createAction(
  C.ACTION_TYPES.FAVOURITE_CLEAR_SHOP_ITEMS
);

export const actionAddFavouriteShopItem = createAction(
  C.ACTION_TYPES.FAVOURITE_ADD_SHOP_ITEMS,
  (items: ShopItem[]) => ({ items })
);

const addItemToFavouriteApi = (
  shop_items: ShopItem[],
  data_items: DataItem[]
): I.ThunkAction => async (dispatch, getState) => {
  // TODO: handle error
  if (shop_items.length > 0) {
    const ok = await api.favourite.addShopItemToFavourite(shop_items);
    ok &&
      dispatch(
        actionAddItemToFavourite({ shop_items, updateFocusedItem: true })
      );
  }
  if (data_items.length > 0) {
    const ok = await api.favourite.addDataItemToFavourite(data_items);
    ok &&
      dispatch(
        actionAddItemToFavourite({ data_items, updateFocusedItem: true })
      );
  }
};

const removeItemFromFavouriteApi = (
  shop_items: ShopItem[],
  data_items: DataItem[]
): I.ThunkAction => async (dispatch, getState) => {
  // TODO: handle error
  if (shop_items.length > 0) {
    const ok = await api.favourite.removeShopItemFromFavourite(shop_items);
    ok && dispatch(actionRemoveFromFavourite(shop_items, []));
  }
  if (data_items.length > 0) {
    const ok = await api.favourite.removeDataItemFromFavourite(data_items);
    ok && dispatch(actionRemoveFromFavourite([], data_items));
  }
};

export const fetchFavouriteDataItems = (payload?: {
  page?: number;
  per_page?: number;
  sorts?: {
    field: string;
    order: string;
  }[];
}): I.ThunkAction => async (dispatch, getState) => {
  dispatch(actionUpdateState(C.STATE.FAVOURITE.IS_FETCHING));
  try {
    const { searchKey } = getState().favourite;
    const data = await api.favourite.fetchFavouriteDataItem({
      ...payload,
      keyword: searchKey,
    });
    if (data.items) {
      // TODO: remove these action
      dispatch(actionAddItemToFavourite({ data_items: data.items }));
      dispatch(actionDataItemView(data.items));

      dispatch(actionAddFavouriteDataItem(data.items));
      dispatch(actionUpdateFavouriteDataItemTotal(data.total));
      dispatch(actionUpdateState(C.STATE.FAVOURITE.DEFAULT));
    }
  } catch (e) {
    dispatch(actionUpdateState(C.STATE.FAVOURITE.SERVER_ERROR));
  }
};

export const resetFetchFavouriteState = () =>
  actionUpdateState(C.STATE.FAVOURITE.DEFAULT);

export const actionOpenDataItemInfo = createAction(
  C.ACTION_TYPES.FAVOURITE_OPEN_DATA_ITEM_INFO,
  (item: DataItem | null) => ({ item })
);

export const getDataItemPrices = (
  dataItems: DataItem[]
): I.ThunkAction => async (dispatch, getState) => {
  dispatch(actionUpdateState(C.STATE.FAVOURITE.IS_FETCHING_GRAPH));
  const json = await api.shop.getDataItemPrices({
    ids: dataItems.map(item => item.id),
  });
  if (!json.items.length) {
    dispatch(actionUpdateState(C.STATE.FAVOURITE.DEFAULT));
    return;
  }

  dispatch(
    actionOpenDataItemInfo({ ...dataItems[0], prices: json.items[0].prices })
  );
  dispatch(actionUpdateState(C.STATE.FAVOURITE.DEFAULT));
};

export const actionOpenMarketReportInfo = createAction(
  C.ACTION_TYPES.FAVOURITE_OPEN_SHOP_ITEM_INFO,
  (item: ShopItem | null) => ({ item })
);

export const actionToggleEditSettings = createAction(
  C.ACTION_TYPES.FAVOURITE_TOGGLE_EDIT_SETTINGS
);

export const actionSetKeyword = createAction(
  C.ACTION_TYPES.FAVOURITE_SEARCH_PRODUCT,
  (searchKey: string) => ({ searchKey })
);

export const actionUpdateFavouriteDataItemTotal = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_DATA_ITEM_TOTAL,
  (total: number) => ({ total })
);
export const actionUpdateFavouriteShopItemTotal = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_SHOP_ITEM_TOTAL,
  (total: number) => ({ total })
);

export const actionSearchFavouriteProduct = (): I.ThunkAction => async (
  dispatch,
  getState
) => {
  dispatch(clearFavouriteDataItems());
  dispatch(actionClearFavouriteShopItems());
  dispatch(fetchFavouriteDataItems());
  dispatch(fetchUserShopItemAll());
};

export const addDataItemsToComparePrice = createAction(
  C.ACTION_TYPES.FAVOURITE_ADD_DATA_ITEMS_TO_COMPARE_PRICE,
  (items: DataItem[], overwrite: boolean) => ({ items, overwrite })
);

export const removeDataItemToComparePrice = createAction(
  C.ACTION_TYPES.FAVOURITE_REMOVE_DATA_ITEMS_TO_COMPARE_PRICE,
  (id: number) => ({ id })
);

export const updateComparePriceFilters = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_COMPARE_PRICE_FILTERS,
  (fitlers: ComparePriceFilters) => ({ fitlers })
);

export const fetchDataItemPrices = (payload: {
  ids?: number[];
  overwrite?: boolean;
  bookmark?: number;
}): I.ThunkAction => async (dispatch, getState) => {
  const { comparePriceFilters, compareDataItems } = getState().favourite;
  const { frequency, ...filters } = comparePriceFilters;
  dispatch(actionUpdateState(C.STATE.FAVOURITE.IS_FETCHING_GRAPH));
  const data = await api.shop.getDataItemPrices({
    ids: payload.ids || compareDataItems.map(item => item.id),
    bookmark: payload.bookmark,
    ...filters,
  });

  dispatch(addDataItemsToComparePrice(data.items, !!payload.overwrite));
  dispatch(fetchReferencePrice());
  dispatch(actionUpdateState(C.STATE.FAVOURITE.DEFAULT));
};

export const actionOpenTradeFromDrawer = createAction(
  C.ACTION_TYPES.FAVOURITE_OPEN_TRADE_FORM_DRAWER,
  (item: DataItem | null) => ({ item })
);

export const updateReferenceYear = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_REFERENCE_YEAR,
  (year: number) => ({ year })
);

export const updateReferencePrice = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_REFERENCE_PRICE,
  (price: ReferencePriceProps) => ({ price })
);

export const updateReferenceProduct = createAction(
  C.ACTION_TYPES.FAVOURITE_UPDATE_REFERENCE_PRODUCT,
  (id: number) => ({ id })
);

export const fetchReferencePrice = (): I.ThunkAction => async (
  dispatch,
  getState
) => {
  const { compareDataItems } = getState().favourite;
  const data = await api.shop.getReferencePrices({
    ids: compareDataItems.map(item => item.id),
    year_before: 3,
  });
  dispatch(updateReferencePrice(data));
};



// WEBPACK FOOTER //
// ./app/actions/favouriteActionCreators.ts